module.exports = __webpack_public_path__ + "img/marketer.1ab8d97a.svg";